import React, { FC, ReactNode } from 'react';

interface NavigationContentProps {
    searchButton: ReactNode;
    navigation: ReactNode;
}

export const NavigationContent: FC<NavigationContentProps> = ({ searchButton, navigation }) => (
    <>
        {navigation}
        {searchButton}
    </>
);
